const FOCUSABLE_SELECTORS = 'input:not([disabled]),textarea:not([disabled]),select:not([disabled]),button:not([disabled]),object,a[href],[tabindex]:not([tabindex="-1"])';

export { FOCUSABLE_SELECTORS };
//# sourceMappingURL=focusable-selectors.js.map
